import styled from "styled-components";

export const TotalSummaryContainer = styled.div`
  align-content: flex-start;
  justify-content: flex-start;
`;
